import { AtSign, MessagesSquare, FolderKanban, User, CheckSquare, FileText, AlertTriangle, Info, Trash2, RotateCcw } from "lucide-react";
import { api } from "@/lib/api";
import { toast } from "sonner";

export const ICONS = { mention: AtSign, team_message: MessagesSquare, application: FolderKanban, client: User, task: CheckSquare, document: FileText, message: AlertTriangle, retainer: FileText, deletion_request: Trash2, lead_recontact: RotateCcw };

const TYPE_CAT = { mention: "mentions", team_message: "team", message: "client_messages", application: "cases", task: "tasks", document: "documents", retainer: "documents", deletion_request: "deletion" };
export const CATEGORIES = [["mentions", "Mentions"], ["team", "Team messages"], ["client_messages", "Client messages"], ["cases", "Cases"], ["tasks", "Tasks"], ["documents", "Documents/Retainers"], ["deletion", "Deletion requests"], ["other", "Other"]];
export const catOf = (n) => TYPE_CAT[n.type] || "other";

export const isPendingRequest = (n) => n.type === "deletion_request" && n.meta?.request_id && (n.meta?.request_status || "pending") === "pending";

// legacy notifications used /staff/... paths; the staff UI lives under /admin
export const resolveLink = (link) => (link || "").replace(/^\/staff\/messages/, "/admin/communications").replace(/^\/staff\//, "/admin/");

export const ago = (iso) => {
  const s = Math.max(0, (Date.now() - new Date(iso).getTime()) / 1000);
  if (s < 60) return "just now";
  if (s < 3600) return `${Math.floor(s / 60)}m ago`;
  if (s < 86400) return `${Math.floor(s / 3600)}h ago`;
  return `${Math.floor(s / 86400)}d ago`;
};

const dayKey = (d) => `${d.getFullYear()}-${d.getMonth()}-${d.getDate()}`;
export const groupByDay = (items) => {
  const today = new Date(); const yest = new Date(); yest.setDate(today.getDate() - 1);
  const groups = { Today: [], Yesterday: [], Earlier: [] };
  items.forEach((n) => {
    const k = dayKey(new Date(n.created_at));
    groups[k === dayKey(today) ? "Today" : k === dayKey(yest) ? "Yesterday" : "Earlier"].push(n);
  });
  return Object.entries(groups).filter(([, xs]) => xs.length);
};

export const decideRequest = async (n, which) => {
  try {
    const r = await api.post(`/deletion-requests/${n.meta.request_id}/${which}`);
    if (which === "approve") {
      toast.success("Deletion approved", r.data.undo_token ? { duration: 10000, action: { label: "Undo", onClick: () => api.post(`/deleted-items/${r.data.undo_token}/restore`).then(() => toast.success("Restored")).catch((e) => toast.error(e?.response?.data?.detail || "Could not restore")) } } : undefined);
    } else toast.message("Deletion declined");
    return true;
  } catch (e) { toast.error(e?.response?.data?.detail || "Action failed"); return false; }
};

// Resolve a notification's destination on the server (also marks it read) and navigate there.
export const openNotification = async (n, nav, { mobile = false } = {}) => {
  if (!n.link) { if (!n.read) api.put(`/notifications/${n.id}/read`).catch(() => {}); return; }
  try {
    const { data } = await api.get(`/notifications/${n.id}/target`);
    if (!data.exists) { toast.message("This item was removed"); return; }
    const to = mobile ? data.mobile : data.desktop;
    if (to) nav(to);
  } catch { toast.error("Couldn't open this notification"); }
};
